<ng-container *transloco="let t">
<div class="dropzone" appDnd (fileDropped)="onFilesDropped($event)">
  <input type="file" #fileDropRef id="fileDropRef" multiple (change)="onFilesSelected($event)" />
  <img src="assets/images/dnd/ic-upload-file.svg" alt="">
  <h3>{{ t('shared.fileUpload.dragDrop') }}</h3>
  <h3>{{ t('common.or') }}</h3>
  <label for="fileDropRef">{{ t('shared.fileUpload.browse') }}</label>
  <br><br>
  <h6>(.txt, .pdf, .doc, .docx, .jpg, .jpeg, .png)</h6>
</div>

<file-list [files]="files" [isUploading]="isUploading" (fileDeleted)="onFileDeleted()"></file-list>

<button class="btn btn-success btn-sm" style="float: right;" [disabled]="files.length === 0 || isUploading" (click)="onUploadClicked()">
  {{isUploading ? t('common.uploading') : t('common.upload')}}
</button>
</ng-container>
